<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" v-if="loanTypes.length">
				<span class="ml-2">فیلترها: </span>
				<v-btn-toggle v-model="loanTypeFilter" dense tile outlined color="purple" class="mr-2 flex-wrap">
					<v-btn v-for="loanType in loanTypes" :key="loanType.id" :value="loanType.id" small>
						{{ loanType.title }}
						<v-badge color="blue"
							:content="loanType.id === 0 ? items.length : items.filter(x => x.userLoan.loanModel.id == loanType.id).length || '0'"
							inline>
						</v-badge>
					</v-btn>
				</v-btn-toggle>
			</v-col>
			<v-col cols="11">
				<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید"
					single-line hide-details class="mb-5" />
			</v-col>
			<v-col cols="1">
				<export-excel :items="items" :headers="headers" :fileName="'لیست پرونده وام های نماینده'">
				</export-excel>
			</v-col>
			<v-col cols="12">
				<v-data-table :headers="headers" :loading="loading" :items="filteredItems" :items-per-page="500" :search="search"
					class="elevation-1">
					<template v-slot:item="row">
						<tr>
							<td>{{ row.item.userLoan.code }}</td>
							<td>{{ row.item.userLoan.loanModel.title }}</td>
							<td>
								{{ row.item.userLoan.memberModel.fullName }}
								<div class="grey--text">کد ملی: {{ row.item.userLoan.memberModel.nationalCode }}</div>
							</td>
							<td class="text-center">{{ row.item.userLoan.startDate_Persian.date }}</td>
							<td class="text-center">
								{{ row.item.userLoan.amount.toString().toPriceFormat() }}
							</td>
							<td class="text-center">
								{{ row.item.amount.toString().toPriceFormat() }}
							</td>
							<td class="text-center">
								<div class="info--text" style="cursor: pointer;" @click="transactionList(row.item)">{{
									row.item.sumSponsorPayments.toString().toPriceFormat() }}</div>
								<div @click="transaction(row.item)"><small class="secondary--text" style="cursor: pointer;">ثبت
										واریزی</small></div>
							</td>
						</tr>
					</template>
				</v-data-table>
			</v-col>
		</v-row>

		<v-dialog v-model="dialogTransaction" scrollable max-width="925px">
			<v-card>
				<v-card-title>
					<div><span class="headline"></span></div>
					<v-spacer />
					<v-btn @click="dialogTransaction = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<ModifyTransaction v-if="dialogTransaction" :data="selectedTransaction" @callbck="callbck_transaction" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogMarketerTransactionsList" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست واریزی ها</span></div>
					<v-spacer />
					<v-btn @click="dialogMarketerTransactionsList = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<MarketerTransactions v-if="dialogMarketerTransactionsList" :marketer="marketer"
						:customerMarketerCommission="selectedCommission" @update="() => { loadData(); $emit('update') }" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
import api from '@/util/app-api'
import toast from '@/util/toast'
import { emptyId } from '@/util/emptyId'

export default {
	name: 'MarketerUserLoans',
	props: {
		marketer: { type: Object },
	},
	components: {
		ConfirmDlg: () => import('@/components/Confirm'),
		MarketerTransactions: () => import('./MarketerTransactions.vue'),
		ModifyTransaction: () => import('@/views/admin/ModifyTransaction'),
	},
	data() {
		return {
			selectedTransaction: null,
			selectedCommission: null,
			dialogTransaction: false,
			dialogMarketerTransactionsList: false,
			errorMessages: '',
			search: '',
			loading: false,
			headers: [
				{
					text: 'شماره وام',
					align: 'start',
					sortable: true,
					value: 'code',
					width: 50
				}, {
					text: 'عنوان وام',
					align: 'start',
					sortable: true,
					value: 'loanModel.title',
				},
				{
					text: 'نام مشتری',
					align: 'start',
					sortable: true,
					value: 'memberModel.fullName',
					width: 150
				},
				{
					text: 'کد ملی',
					align: 'start d-none',
					sortable: true,
					value: 'memberModel.nationalCode',
				},
				{
					text: 'تاریخ شروع وام',
					align: 'center',
					sortable: true,
					value: 'startDate_Persian',
				},
				{
					text: 'مبلغ',
					align: 'center',
					sortable: true,
					value: 'amount',
				},
				{
					text: 'سهم بازاریاب',
					align: 'center',
					sortable: true,
					value: 'agentPrice',
				},
				{
					text: 'مجموع واریز اسپانسر',
					align: 'center',
					sortable: false,
					value: 'sumSponsorPayments'
				}
			],
			items: [],
			loanTypes: [],
			loanTypeFilter: '',
		}
	},
	mounted() {
		this.loadData()
	},
	computed: {
		filteredItems() {
			if (!this.loanTypeFilter)
				return this.items
			let clonedItems = []
			clonedItems.push(...this.items)
			clonedItems = clonedItems.filter(x => this.loanTypeFilter.indexOf(x.userLoan.loanModel.id) > -1)
			return clonedItems
		}
	},
	methods: {
		loadData() {
			this.loading = true
			api.get('customermarketer/commissions/List/' + this.marketer.id, null)
				.then(response => {
					this.items = response
					this.loanTypes = Object.values(
						response.reduce((acc, obj) => ({ ...acc, [obj.userLoan.loanModel.id]: obj.userLoan.loanModel }), {})
					)
					if (this.loanTypes.length) {
						this.loanTypes.push({ id: 0, title: 'همه' })
						this.loanTypeFilter = 0
					}
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		transaction(item) {
			this.selectedTransaction = { id: emptyId, paymentMethod: 2, isWithdraw: true, customerMarketerCommission: { id: item.id, title: `شماره وام: ${item.userLoan.code}, عنوان: ${item.userLoan.loanModel.title}`, code: item.userLoan.code, marketer: { id: this.marketer.id, businessName: this.marketer.firstName + ' ' + this.marketer.businessName, mobile: this.marketer.mobile, firstName: this.marketer.firstName, bankAccountsJson: this.marketer.bankAccountsJson } }, amount: Math.max(item.amount - item.sumSponsorPayments, 0), maxAmount: item.amount - item.sumSponsorPayments }
			this.dialogTransaction = true
		},
		callbck_transaction(result) {
			this.dialogTransaction = false
			if (result) {
				this.loadData()
				this.$emit('update')
			}
		},
		transactionList(commission) {
			this.selectedCommission = commission
			this.dialogMarketerTransactionsList = true
		}
	},
}
</script>
<style></style>
